import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "over_view"
};
const _hoisted_2 = {
  class: "ov_real_time"
};
const _hoisted_3 = {
  class: "ov_header"
};

const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, "实时监控", -1);

const _hoisted_5 = {
  key: 1
};
const _hoisted_6 = {
  class: "ov_content"
};

const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "ov_content_title"
}, "付款产品数量", -1);

const _hoisted_8 = {
  class: "ov_content_box"
};
const _hoisted_9 = {
  class: "ov_content_total"
};

const _hoisted_10 = /*#__PURE__*/_createElementVNode("b", null, "收款金额（元）", -1);

const _hoisted_11 = {
  class: "ov_content_total"
};

const _hoisted_12 = /*#__PURE__*/_createElementVNode("b", null, "付款买家数", -1);

const _hoisted_13 = {
  class: "ov_content_total"
};

const _hoisted_14 = /*#__PURE__*/_createElementVNode("b", null, "退款金额（元）", -1);

const _hoisted_15 = {
  class: "ov_content_total"
};

const _hoisted_16 = /*#__PURE__*/_createElementVNode("b", null, "新增会员数", -1);

const _hoisted_17 = {
  class: "ov_ranking_list"
};
const _hoisted_18 = {
  class: "ov_header"
};

const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", null, "排行榜", -1);

const _hoisted_20 = {
  class: "ov_header_date"
};
const _hoisted_21 = {
  class: "ov_ranking_item"
};
import BarChart from "@/components/overview/BarChart.vue";
import GeoLeaderboards from "@com/overview/GeoLeaderboards.vue";
import { ref } from "vue";
import useRoute from "@util/router";
import api from "@api/overview";
import auth from "@net/auth";
export default {
  __name: 'OverView',

  setup(__props) {
    const permission = auth.getOverView();
    const route = useRoute();
    const allView = permission.isAll;

    if (!allView) {
      searchBase(permission.shopCode);
    } else {
      getConfig();
      getData();
    }

    route.watchRouter("overview", () => {
      getData();
    });
    const baseOptions = ref([]);
    const dateOptions = [{
      label: "今日",
      value: 0
    }, {
      label: "昨日",
      value: 1
    }, {
      label: "近7日",
      value: 2
    }];

    function getConfig() {
      api.base(val => {
        val.unshift({
          label: "全部基地",
          value: "all"
        });
        baseOptions.value = val;
      });
    }

    const base = ref(route.query().base || "all");
    const date = ref(route.query().date || 0);

    function searchDate(val) {
      route.replaceQuery("date", val);
    }

    function searchBase(val) {
      route.replaceQuery("base", val);
    }

    const rankingList = [{
      which: 1,
      title: "单一商品访问量",
      dataKey: "shopVisitItemList"
    }, {
      which: 2,
      title: "商品购买榜",
      dataKey: "productItemItemList"
    }, {
      which: 3,
      title: "旅行产品购买榜",
      dataKey: "travelItemList"
    }, {
      which: 4,
      title: "酒店预订榜",
      dataKey: "hotelItemList"
    }];
    const timeData = ref({
      todayMoney: null,
      yestodayMoney: null,
      comparedMoney: null,
      todayRefundMoney: null,
      yestodayRefundMoney: null,
      comparedRefundMoney: null,
      todayPayMember: null,
      yestodayPayMember: null,
      comparedPayMember: null,
      todayRegisteMember: null,
      yestodayRegisterMember: null,
      comparedRegisterMember: null,
      orderItem: []
    });
    const rankingData = ref({
      shopVisitItemList: [],
      productItemItemList: [],
      travelItemList: [],
      hotelItemList: []
    });

    function getData() {
      realTime();
      rankTop();
    }

    function realTime() {
      let routeQuery = route.query();
      api.realTime({
        shopCode: routeQuery.base
      }, val => {
        timeData.value = val;
      });
    }

    function rankTop() {
      let routeQuery = route.query();
      api.rankTop({
        shopCode: routeQuery.base,
        dateType: routeQuery.date
      }, val => {
        rankingData.value = val;
      });
    }

    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_radio_button = _resolveComponent("el-radio-button");

      const _component_el_radio_group = _resolveComponent("el-radio-group");

      const _component_el_date_picker = _resolveComponent("el-date-picker");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _unref(allView) ? (_openBlock(), _createBlock(_component_el_select, {
        key: 0,
        modelValue: base.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => base.value = $event),
        onChange: searchBase
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(baseOptions.value, (item, index) => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: index,
            label: item.label,
            value: item.value
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])) : (_openBlock(), _createElementBlock("div", _hoisted_5, "当前基地：" + _toDisplayString(_unref(permission).shopName), 1))]), _createElementVNode("div", _hoisted_6, [_hoisted_7, _createVNode(_component_el_row, {
        gutter: 20
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 15
        }, {
          default: _withCtx(() => [_createVNode(BarChart, {
            chartData: timeData.value.orderItem
          }, null, 8, ["chartData"])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 9
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createVNode(_component_el_row, {
            gutter: 20
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("h2", null, _toDisplayString(timeData.value.todayMoney || 0), 1), _createElementVNode("div", null, [_createTextVNode(" 昨日： "), _createElementVNode("span", null, _toDisplayString(timeData.value.yestodayMoney || 0), 1), _createElementVNode("span", null, _toDisplayString(timeData.value.comparedMoney || 0), 1)])])]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("h2", null, _toDisplayString(timeData.value.todayPayMember || 0), 1), _createElementVNode("div", null, [_createTextVNode(" 昨日： "), _createElementVNode("span", null, _toDisplayString(timeData.value.yestodayPayMember || 0), 1), _createElementVNode("span", null, _toDisplayString(timeData.value.comparedPayMember || 0), 1)])])]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_13, [_hoisted_14, _createElementVNode("h2", null, _toDisplayString(timeData.value.todayRefundMoney || 0), 1), _createElementVNode("div", null, [_createTextVNode(" 昨日： "), _createElementVNode("span", null, _toDisplayString(timeData.value.yestodayRefundMoney || 0), 1), _createElementVNode("span", null, _toDisplayString(timeData.value.comparedRefundMoney || 0), 1)])])]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("h2", null, _toDisplayString(timeData.value.todayRegisteMember || 0), 1), _createElementVNode("div", null, [_createTextVNode(" 昨日： "), _createElementVNode("span", null, _toDisplayString(timeData.value.yestodayRegisterMember || 0), 1), _createElementVNode("span", null, _toDisplayString(timeData.value.comparedRegisterMember || 0), 1)])])]),
              _: 1
            })]),
            _: 1
          })])]),
          _: 1
        })]),
        _: 1
      })])]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_hoisted_19, _createElementVNode("div", _hoisted_20, [_createVNode(_component_el_radio_group, {
        modelValue: date.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => date.value = $event),
        onChange: searchDate
      }, {
        default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(dateOptions, (item, index) => {
          return _createVNode(_component_el_radio_button, {
            key: index,
            label: item.value
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
            _: 2
          }, 1032, ["label"]);
        }), 64))]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_date_picker, {
        modelValue: date.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => date.value = $event),
        type: "daterange",
        "range-separator": "~",
        "start-placeholder": "开始时间",
        "end-placeholder": "结束时间",
        "value-format": "YYYY-MM-DD",
        onChange: searchDate
      }, null, 8, ["modelValue"])])]), _createVNode(_component_el_row, {
        gutter: 20
      }, {
        default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(rankingList, (item, index) => {
          return _createVNode(_component_el_col, {
            key: index,
            span: 12
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_21, [_createVNode(GeoLeaderboards, {
              title: item.title,
              which: item.which,
              data: rankingData.value[item.dataKey]
            }, null, 8, ["title", "which", "data"])])]),
            _: 2
          }, 1024);
        }), 64))]),
        _: 1
      })])]);
    };
  }

};